import {autorun, observable} from "mobx";
import {MobXHelper, VarHelper} from "common-import/helpers";
import api from "./User.API";

const { makePersit } = MobXHelper;

const GlobalEvent = require('js-events-listener');

const PERSIST_STORE_ITEM = {
  USER_DATA: "USER_STORE_USER_DATA"
};

class UserStore {
  constructor() {
    this.loadInitialData();
  }

  @observable userData = {};
  @observable listUser = [];
  @observable userDetail = {};

  getToken = () => this.userData.keyJWT;

  loadInitialData = async () => {
    let userData = await makePersit.persist(PERSIST_STORE_ITEM.USER_DATA, "object");
    if (userData !== undefined) this.userData = userData;

    let res = await this.getUserInfo();
    if (res.data !== undefined) {
      this.userData = {...this.userData, ...res.data};
    } else if (res.error === 'NOT_AUTHEN' && this.getToken() !== undefined) {
      alert('Your session has expired. Please login again!');
      this.logout();
    } else if (res.error === 'NOT_AUTHEN') {
      alert('You have to login first!');
      this.logout();
    }
    GlobalEvent.emit("USER_STORE_READY", this.userData);
  };

  onReady = callback => new Promise((resolve, reject) => {
    const run = () => {
      typeof callback === 'function' && callback(this.userData);
      resolve(this.userData);
    };
    if (this.isAuth()) run();
    else GlobalEvent.on("USER_STORE_READY", run);
  });

  isAuth = () => {
    if (this.userData === undefined) return false;
    return typeof this.userData.keyJWT === "string";
  };

  register = async (obj) => {
    let res = await api.register(obj);
    if (!!res.validateError) {
      return { error: res.validateError };
    }
    return await res.json();
  };

  loginNormal = async ({ email, password }) => {
    let res = await api.loginNormal({ email, password, type: "normal" });
    let json = await res.json();
    if(!!json.error) return json;
    if (!json.data.isSuperAdmin) return { error: 'Tài khoản này không có quyền truy cập vào admin' };
    this.userData = json.data;
    return json;
  };

  getUserInfo = async () => {
    let res = await api.me();
    return await res.json();
  };

  logout = async () => {
    await api.logout();
    this.userData = {};
    localStorage.clear();
    // location.reload();
    document.location = "/#/login";
    return null;
  };

  adminList = async data => {
    let res = await api.adminList(data);
    let json = await res.json();
    if (!!json.error) return json;
    this.listUser = VarHelper.cloneDeep(json.data);
    return json;
  };

  getUserDetailById = async id => {
    let res = await api.detail(id);
    return await res.json();
    // this.userDetail = VarHelper.cloneDeep(json.data);
  };

  update = async (data) => {
    const res = await api.update(data);
    if (res.validateError) {
      return { error: res.validateError };
    }
    const json = await res.json();
    if (!!json.error) return json;
    this.userDetail = VarHelper.cloneDeep(json.data);
    return json;
  };

  blockUser = async ({id}) => {
    const res = await api.blockUser({id});
    if (res.validateError) {
      return { error: res.validateError };
    }
    return await res.json();
  };

  unBlockUser = async ({id}) => {
    const res = await api.unBlockUser({id});
    if (res.validateError) {
      return { error: res.validateError };
    }
    return await res.json();
  };

  search = async ({email}) => {
    const res = await api.search({email});
    if (res.validateError) {
      return { error: res.validateError };
    }
    return await res.json();
  };
}

const userStore = new UserStore();

autorun(() => {
  makePersit.make(userStore.userData, PERSIST_STORE_ITEM.USER_DATA)
});

export default userStore;



// WEBPACK FOOTER //
// ./src/services/user/User.Store.js